import { makeAutoObservable } from 'mobx'

import { Collection } from '@flowwai-frontend/shared/sales-crm/sales-crm-core'

class DynamicFeatureTogglesStore {
   private _dynamicConfigCollection: Collection<string, any>

   constructor() {
      this._dynamicConfigCollection = new Collection<string, any>(
         "The DynamicConfig you are trying to access doesn't exist"
      )
      makeAutoObservable(this)
   }

   getDynamicConfig(key: string): any {
      return this._dynamicConfigCollection.getItem(key)
   }

   hasDynamicConfig(key: string): boolean {
      return this._dynamicConfigCollection.hasItem(key)
   }

   addDynamicConfig(key: string, value: any): void {
      this._dynamicConfigCollection.addItem(key, value)
   }

   static create = (): DynamicFeatureTogglesStore =>
      new DynamicFeatureTogglesStore()
}

export default DynamicFeatureTogglesStore
